import { getQuickcamCoinStage } from '../../environments';

export type { QccNetworkId } from './qcc-balance-chains';

export function isQccBalancePreviewEnabled(
  href = typeof window !== 'undefined' ? window.location.href : '',
): boolean {
  return getQuickcamCoinStage(href) !== 'prod';
}

export function formatQccAmount(amount: number): string {
  return amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
